import React from 'react';

const JSON_Intro = () => {
  return (
    <div >
      <h1>JSON_Intro</h1>
      <p>Placeholder component for: "JSON Intro"</p>
    </div>
  );
};

export default JSON_Intro;
